import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percent'
})
export class PercentPipe implements PipeTransform {

    transform(value: number): string {
        if(value < 1) {
            return Math.round(100 - 100 * value) + '%';
        }
        else if(value > 1) {
            return Math.round(100 * value - 100) + '%';
        }
        else {
            return '0%';
        }
    }

}
